import { useTheme } from "@mui/material";
import BrandSelector from "~components/atoms/BrandSelector";
import * as S from "./styles";

const Logo = () => {
  const theme: any = useTheme();

  return (
    <S.Wrapper theme={theme}>
      <S.Brand>
        <S.Title>AzzasLive</S.Title>
      </S.Brand>
      <BrandSelector />
    </S.Wrapper>
  );
};

export default Logo;
